const WEEKDAYS = '日一二三四五六'
const TAIPEI_OFFSET_MS = 8 * 60 * 60 * 1000
const MODE_LABELS = {
  '-100.1': '私訊預約',
  '-100.2': '私訊預約',
  '-100.9': '私訊預約',
  '0': '不開放線上預約',
  '1': '登記預約',
  '2': '系統自動篩選',
  '3': '手動空檔',
}

export const SLOT_CLOSED_CHIP = { color: '#E0E0E0', textColor: '#9E9E9E' }

const pad = n => String(n).padStart(2, '0')

const toUtcDate = date => {
  const [year, month, day] = date.split('-').map(Number)
  return new Date(Date.UTC(year, month - 1, day))
}

// 休診日一律指台灣的看診日，不能依瀏覽器時區判斷今天
export function taipeiToday(now = Date.now()) {
  return new Date(now + TAIPEI_OFFSET_MS).toISOString().slice(0, 10)
}

export function formatClosureDate(date) {
  const d = toUtcDate(date)
  return `${d.getUTCMonth() + 1}/${d.getUTCDate()}（${WEEKDAYS[d.getUTCDay()]}）`
}

export function formatClosureDateWithYear(date) {
  return `${date.slice(0, 4)}/${formatClosureDate(date)}`
}

export function appointmentModeLabel(doctor) {
  const statuses = [
    doctor.line_appointment_status,
    doctor.web_appointment_status,
    doctor.google_map_appointment_status,
  ]
  const labels = statuses.map(status => MODE_LABELS[String(status)]).filter(Boolean)
  return [...new Set(labels)].join('、')
}

export function selectableFirst(doctors) {
  return [
    ...doctors.filter(doctor => doctor.selectable),
    ...doctors.filter(doctor => !doctor.selectable),
  ]
}

export function selectableCodes(doctors) {
  return doctors.filter(doctor => doctor.selectable).map(doctor => doctor.doctor_code)
}

// originalExcluded 裡暫時不能勾的醫師要原樣保留，否則他改回空檔模式時，這天會被改成關閉
export function buildExcludedCodes(doctors, checkedCodes, originalExcluded = []) {
  const selectable = selectableCodes(doctors)
  const unchecked = selectable.filter(code => !checkedCodes.includes(code))
  const kept = originalExcluded.filter(code => !selectable.includes(code))
  return [...kept, ...unchecked]
}

export function closedDatesForDoctor(upcoming, doctorCode) {
  if (!doctorCode) return []
  const code = doctorCode.toLowerCase()
  return upcoming
    .filter(day => day.closed_doctors.some(doctor => doctor.doctor_code.toLowerCase() === code))
    .map(day => day.date)
}

export function summarizeDoctorNames(closedDoctors) {
  const names = closedDoctors.map(doctor => `${doctor.doctor_name}醫師`)
  const full = names.join('、')
  if (names.length <= 4) return { text: full, title: '' }
  return { text: `${names.slice(0, 3).join('、')} 等 ${names.length} 位`, title: full }
}

export function buildCalendarCells(year, monthIndex) {
  const firstWeekday = new Date(Date.UTC(year, monthIndex, 1)).getUTCDay()
  const dayCount = new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate()
  const cells = new Array(firstWeekday).fill(null)
  for (let day = 1; day <= dayCount; day++) {
    cells.push({ date: `${year}-${pad(monthIndex + 1)}-${pad(day)}`, day })
  }
  return cells
}

// messages 是 -99999 時 main.js 的攔截器已經提示過，這裡回空字串避免把代碼顯示給使用者
export function closureErrorMessage(error) {
  const messages = error?.response?.data?.messages
  if (messages === '-99999') return ''
  return typeof messages === 'string' && messages ? messages : '操作失敗，請稍後再試'
}

// toggle 只動能勾的醫師；一個都沒有時不能算「全選」
export function checkState(doctors, checkedCodes) {
  const selectable = selectableCodes(doctors)
  const count = selectable.filter(code => checkedCodes.includes(code)).length
  return {
    all: selectable.length > 0 && count === selectable.length,
    some: count > 0 && count < selectable.length,
  }
}

export function toggleAllCodes(doctors, checkedCodes) {
  return checkState(doctors, checkedCodes).all ? [] : selectableCodes(doctors)
}

// 已結束的紀錄只有 closed_doctors，沒有 excluded_doctor_codes，未來的紀錄也用同一欄才一致
export function copyableCodes(doctors, closure) {
  const closed = closure.closed_doctors.map(doctor => doctor.doctor_code)
  return selectableCodes(doctors).filter(code => closed.includes(code))
}
